"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import * as Aria from 'react-aria-components';
import styles from './TabList.module.scss.mjs';
import { TunnelExit } from '@mittwald/react-tunnel';
import { useObserveOverflow } from '../../../../lib/hooks/dom/useObserveOverflow.mjs';
import { ContextMenu } from '../../../ContextMenu/ContextMenu.mjs';
import { ContextMenuTrigger } from '../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import { Button } from '../../../Button/Button.mjs';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconContextMenu } from '../../../Icon/components/icons/IconContextMenu.mjs';
import clsx from 'clsx';
import { TabTitleCollapsed } from '../TabTitle/TabTitleCollapsed.mjs';

const TabList = (props) => {
  const { selection, disabledKeys, onContextMenuSelectionChange } = props;
  const titleCollapsedElementId = useId();
  const overflowObserver = useObserveOverflow();
  const isCollapsed = overflowObserver.isOverflowing;
  const rootClassName = clsx(styles.tabList, isCollapsed && styles.collapsed);
  const handleContextMenuSelectionChange = (key) => {
    onContextMenuSelectionChange(key);
  };
  const regularTabTitles = /* @__PURE__ */ jsx(Aria.TabList, { className: styles.titles, ref: overflowObserver.ref, children: /* @__PURE__ */ jsx(TunnelExit, { id: "Titles" }) });
  const singleTabTitleWhenCollapsed = isCollapsed && /* @__PURE__ */ jsx(TabTitleCollapsed, { id: titleCollapsedElementId });
  const contextMenuWhenCollapsed = isCollapsed && /* @__PURE__ */ jsxs(ContextMenuTrigger, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "soft",
        className: styles.contextMenuButton,
        color: "secondary",
        "aria-labelledby": titleCollapsedElementId,
        children: /* @__PURE__ */ jsx(IconContextMenu, {})
      }
    ),
    /* @__PURE__ */ jsx(
      ContextMenu,
      {
        disabledKeys,
        selectedKeys: selection ? [selection] : void 0,
        selectionMode: "navigation",
        onAction: (key) => handleContextMenuSelectionChange(key),
        children: /* @__PURE__ */ jsx(TunnelExit, { id: "ContextMenuItems" })
      }
    )
  ] });
  return /* @__PURE__ */ jsxs("div", { className: rootClassName, children: [
    regularTabTitles,
    singleTabTitleWhenCollapsed,
    contextMenuWhenCollapsed
  ] });
};

export { TabList };
//# sourceMappingURL=TabList.mjs.map
